import { getCurrentAccountId } from 'redux/selectors/accounts';
import { getUserId } from 'redux/selectors/user';
import { createSelector } from 'reselect';

export const getPrivatePusherChannelName = createSelector(
  [getCurrentAccountId, getUserId],
  (accountId, userId): string => `private-${accountId}-${userId}`
);

/** Channel name user for BE/TIC -> FE Pusher comms */
export const getPrivateTicPusherChannelName = createSelector(
  [getUserId],
  (userId): `private-${number}` => `private-${userId}`
);

/** Channel for account-wide notifications from TIC -> FE */
export const getAccountTicPusherChannelName = createSelector(
  [getCurrentAccountId],
  (accountId): `account-${number}` => `account-${accountId}`
);

export const getAccountPusherChannelNames = createSelector([getCurrentAccountId], accountId => {
  const byPostfix = (postfix: string) => `private-global-${accountId}-${postfix}`;
  return {
    labels: byPostfix('labels'),
    forecasts: byPostfix('forecasts'),
    /** Bulk hour operations */
    hours: byPostfix('hours'),
  };
});
export const getAccountPusherChannelName = createSelector(
  [getCurrentAccountId],
  accountId => (postfix: string) => `private-global-${accountId}-${postfix}`
);

/** Channel for account-wide Pusher notifications (private-account-{accountId}) */
export const getPrivateAccountPusherChannelName = createSelector(
  [getCurrentAccountId],
  (accountId): string => `private-account-${accountId}`
);
